export const CARD_BACKGROUND_COLOR = ['#FFFFFF', '#69B1FC', '#65BB5A', '#FF5656', '#FFAA2C', '#86469C', '#000000']
